<template>
  <div class="comments-composer">
    <div class="comments-composer-content">
      <former-input
        :disabled="processing"
        :field="field"
        :value="value"
        color="white"
        class="comments-composer-text"
        size="big"
        @input="input"
        @keydown.native.enter="submit"
      />

      <former-submit
        :processing="processing"
        class="comments-composer-submit"
        icon="paper-plane"
        @submit="submit"
      />
    </div>
  </div>
</template>

<script>
  import FormerInput from '@/components/Former/Field/Input.vue';
  import FormerSubmit from '@/components/Former/Field/Submit.vue';

  export default {
    name: 'CommentsComposer',
    components: {
      FormerInput,
      FormerSubmit,
    },
    props: {
      processing: {
        type: Boolean,
        default: false,
      },
      value: {
        type: String,
        default: '',
      },
      field: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    methods: {
      input(value) {
        this.$emit('input', value);
      },
      submit() {
        this.$emit('submit');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .comments-composer {
    background-color: $gray-light;
    margin-bottom: calc(env(safe-area-inset-bottom) * -1);
    padding-bottom: env(safe-area-inset-bottom);
  }

  .comments-composer-content {
    align-items: stretch;
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    padding: $gutter-smaller;
    padding-left: 0;

    @media all and (min-width: $breakpoint-desktop) {
      padding: $gutter;
    }
  }

  .comments-composer-submit {
    align-self: center;
    height: auto !important;

    @media all and (min-width: $breakpoint-desktop) {
      margin-left: $gutter;
    }
  }

  .comments-composer-text {
    flex: 1;
  }
</style>
